import Vue from 'vue'
import Router from 'vue-router'
import Layout from './components/Layout.vue'
import Login from './views/Login/Login.vue'
import Home from './views/Home/Home.vue'
import ContactUs from './views/ContactUs/ContactUs.vue'

Vue.use(Router)

const LoginRoute = {
	path: '',
	name: 'login',
	component: Login,
	alias: 'login',
	meta: { allowAnonymous: true },
}

const HomeRoute = {
	path: 'home',
	name: 'home',
	component: Home,
}

const ContactUsRoute = {
	path: 'contact-us',
	name: 'contact-us',
	component: ContactUs,
	meta: { allowAnonymous: true },
}

const StepRoute = {
	path: 'plans/:planId/steps/:stepId',
	name: 'step',
	component: () => import('./views/Step/Step.vue'),
}

const ApplicationRoute = {
	path: 'plans/:planId/steps/:stepId/flows/:flowId/application',
	name: 'application',
	component: () => import('./views/Application/Application.vue'),
}

const UploadFileRoute = {
	path: 'plans/:planId/steps/:stepId/flows/:flowId/uploadfile',
	name: 'UploadFile',
	component: () => import('./views/UploadFile/UploadFile.vue'),
}

const PaymentRoute = {
	path: 'plans/:planId/steps/:stepId/flows/:flowId/payment',
	name: 'payment',
	component: () => import('./views/Payment/Payment.vue'),
}

const PasswordRoute = [
	{
		path: 'password/forget',
		name: 'password-forget',
		meta: { allowAnonymous: true },
		component: () =>
			import(/* webpackChunkName: "forgetPassword" */ './views/Password/Forget/StudentForgetPassword.vue'),
	},
	{
		path: 'password/change',
		name: 'password-change',
		meta: { allowAnonymous: true },
		component: () =>
			import(/* webpackChunkName: "changePassword" */ './views/Password/Change/StudentChangePassword.vue'),
	},
]

export default new Router({
	routes: [
		{
			path: '/',
			component: Layout,
			children: [
				LoginRoute,
				HomeRoute,
				ContactUsRoute,
				StepRoute,
				ApplicationRoute,
				PaymentRoute,
				...PasswordRoute,
				UploadFileRoute,
			],
		},
	],
})
